angular.module('picmonicng').factory('ClassificationsResource', [
  '$resource',
  function ($resource) {
    return $resource('/api/v3/classifications/:comment_id/:resource');
  },
]);
